export default function ArrowDown() {
    return (
        <svg
            width="12"
            height="12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 5l5 5 5-5" stroke="#2300FF" strokeWidth="2" />
        </svg>
    );
}
